import { FC } from 'react';
import { ComponentMode as Mode } from '@/shared/types';
import { InputDisabledMode } from './InputDisabledMode';
import { InputEdit } from './InputEditMode';
import { InputInputMode } from './InputInputMode';

type Props = {
  id: string;
  mode: Mode;
  label?: string;
  value?: string;
};

export const Input: FC<Props> = ({ id, mode, ...rest }) => {
  switch (mode) {
    case Mode.Edit:
    case Mode.Preview:
      return <InputEdit {...rest} />;
    case Mode.Input:
      return <InputInputMode id={id} {...rest} />;
    case Mode.Disabled:
      return <InputDisabledMode {...rest} />;

    default:
      throw new Error('Invalid component mode provided to Input.tsx');
  }
};
